import {Table} from "antd";
import React, {useState} from "react";
import {useColumns} from "./UseColumns";
import {createUseStyles} from "react-jss";
import {useGetPartners} from "../../hooks/UseGetPartners";
import PartnerCreateButton from "./create/PartnerCreateButton";
import PartnerMap from "./PartnerMap";
import {useGetSelfEmployeeQuery} from "../../store/api/EmployeeApi";
import ErrorAccessDenied from "../../components/error/ErrorAccessDenied";

const useStyles = createUseStyles<string>({
    button: {
        marginBottom: "1rem",
        marginLeft: "8px",
        marginRight: "8px"
    },
    table: {
        padding: "10px",
        borderRadius: "10px",
        boxShadow: "5px 10px 24px 5px rgb(232, 232, 232)"
    }
})

interface MapData {
    latitude: number | undefined,
    longitude: number | undefined
}

const PartnerTable = () => {

    const classes = useStyles()
    const {data: employee} = useGetSelfEmployeeQuery()
    const {partners, onChangeTable, loading, filter, total} = useGetPartners()
    const [visible, setVisible] = useState(false)
    const [mapData, setMapData] = useState<MapData>({latitude: 0, longitude: 0})

    const showMap = (latitude: number | undefined, longitude: number | undefined) => {
        setMapData({latitude, longitude})
        setVisible(true)
    }

    const columns = useColumns({showMap})

    return (
        <>
            <div className={classes.button}>
                {employee?.data?.permission.canCreatePartner && <PartnerCreateButton/>}
            </div>
            {employee?.data?.permission.canReadPartners ?
                <>
                    <Table
                        className={classes.table}
                        components={{body: {cell: undefined}}}
                        bordered
                        columns={columns}
                        loading={loading}
                        rowKey={row => row.id}
                        scroll={{x: 1400}}
                        onChange={onChangeTable}
                        dataSource={partners}
                        pagination={{pageSize: filter.size, current: filter.page, total: total}}
                    />
                    <PartnerMap latitude={mapData.latitude} longitude={mapData.longitude} visible={visible}
                                setVisible={setVisible}/>
                </> : <ErrorAccessDenied/>
            }
        </>
    )

}

export default PartnerTable